import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import Base from 'topmeteo/base/components/Base';

import ContentArea from './ContentArea';
import LegendArea from './LegendArea';
import Controls from './Controls';
import {Map} from './Map';

const ControlsArea = ({showMap, panelOpen, changeRegion}) => (
    <div className={classNames('container', {'panel-open': panelOpen === 'config-header'})}>
        <Base mobile={showMap} changeRegion={changeRegion} />
        <Controls />
        {showMap ? <Map /> : <ContentArea />}
        <LegendArea />
    </div>
);

const mapStateToProps = ({showMap, panelOpen}) => ({showMap, panelOpen});

export default connect(mapStateToProps)(ControlsArea);
